export const MealPlanCookMore = {
  template: `
    <div class="meal-plan-cook-more">
      Where you see the "cook more" symbol <i class="fa fa-lg icon-cookup pl-1"></i>,
      it means you are cooking the meal for the next day as well.
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/MealPlan/MealPlanCookMore.js